"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useResponsiveStyle_1 = require("./hooks/useResponsiveStyle");
var Col_1 = __importDefault(require("./Col"));
var Responsive = function (props) {
    var _a;
    var uniqueId = react_1.useState('responsive_id_' + Math.random())[0];
    var children = props.children, rules = props.rules;
    if (!rules)
        return children;
    var responsiveRule = useResponsiveStyle_1.useResponsiveStyle(rules);
    var childrenArray = react_1.default.Children.toArray(props.hasWrapper ? (_a = children === null || children === void 0 ? void 0 : children.props) === null || _a === void 0 ? void 0 : _a.children : children);
    switch (true) {
        case typeof responsiveRule !== 'string':
            return children;
            break;
        case responsiveRule.includes('%'):
            var percent = Number(responsiveRule.replace('%', ''));
            if (isNaN(percent))
                return children;
            return childrenArray.map(function (child, childIndex) { return (react_1.default.createElement(Col_1.default, { width: responsiveRule, key: 'responsive-r1-' + childIndex + uniqueId }, child)); });
            break;
        case (responsiveRule === '1:.'):
            return childrenArray.map(function (child, childIndex) { return (react_1.default.createElement(Col_1.default, { flex1: true, key: 'responsive-r2-' + childIndex + uniqueId }, child)); });
            break;
        case (responsiveRule.includes(':')):
            var flexs = responsiveRule.split(':').map(function (val) { return val; });
            if (flexs.filter(function (val) { return isNaN(Number(val)) && val !== 'any' && !val.includes('px'); }).length > 0) {
                throw new Error('invalid responsive rule');
            }
            return flexs.map(function (val, i) { return (react_1.default.createElement(Col_1.default, { flex: val === 'any' || val.includes('px') ? undefined : val, width: val.includes('px') ? Number(val.replace('px', '')) : undefined, key: "responsive-r3-" + i + uniqueId }, childrenArray[i])); });
            break;
        default: return children;
    }
};
exports.default = Responsive;
//# sourceMappingURL=Responsive.js.map